import React from "react";
import { connect } from "react-redux";
import { getAuthClaims } from "@redriver/cinnamon";
import { getSheetDataState } from "features/Sheets";
import { claimExists } from "features/../../../shared/components/auth/utils";

const withImpersonatedPermissions = (Component) => {
  const PermissionWrapper = ({ permissions, impersonatedUser, ...props }) => {
    const hasPermission = (target, action, any = false) => {
      if (
        !impersonatedUser ||
        !Object.keys(impersonatedUser.permissions ?? {}).length
      ) {
        return claimExists(permissions, target, action, any);
      }

      const hasActualPermission = claimExists(permissions, target, action, any);
      const hasImpersonatedPermission = claimExists(
        impersonatedUser.permissions,
        target,
        action,
        any,
      );

      return hasActualPermission && hasImpersonatedPermission;
    };

    return (
      <Component
        {...props}
        impersonatedUser={impersonatedUser}
        hasPermission={hasPermission}
      />
    );
  };

  const mapStateToProps = (state) => {
    const { permissions } = getAuthClaims(state);
    const { impersonatedUser } = getSheetDataState(state);
    return {
      permissions,
      impersonatedUser,
    };
  };

  return connect(mapStateToProps, () => ({}))(PermissionWrapper);
};

export default withImpersonatedPermissions;
